module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rkyKYk/tc-custom/9781488045738.jpg?1724535953930",
      "alt": "This image is the cover for the book Girl Who Couldn't Forget"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Girl Who Couldn't Forget\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Twelve years ago, 6 girls were kidnapped. Now, an FBI agent fights to protect them from a killer in this romantic suspense novel.")]), _c('br'), _c('br'), _vm._v("Twelve years ago, Brooke Josephson suffered a horrifying ordeal at the hands of a brutal kidnapper. When her best friend is murdered and a chilling link between the crimes is uncovered, she will do whatever it takes to stop the killer. FBI special agent Justin Sloan can help her. The expert profiler makes Brooke feel safe . . . and desired. She survived before. With his love, can she put the past to rest at last?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cassie Miles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA TODAY bestselling author Cassie Miles lives in Colorado. After raising two daughters and cooking tons of macaroni and cheese for her family, Cassie is trying to be more adventurous in her culinary efforts. She's discovered that almost anything tastes better with wine. When she's not plotting Harlequin Intrigue books, Cassie likes to hang out at the Denver Botanical Gardens near her high-rise home.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0